export var directions = ['row', 'column', 'row-reverse', 'column-reverse'];
export var alignItems = ['flex-start', 'flex-end', 'center', 'stretch', 'baseline'];
export var justifyContent = [
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
    'space-evenly'
];
//# sourceMappingURL=types.js.map